import { HugeiconsIconProps, HugeiconsIcon } from "@hugeicons/react";
import { Checkbox } from "shared/components";
import { cx } from "shared/utils";

export const VerificationMethodRow = ({
  icon,
  label,
  checked,
  onChange
}: {
  icon: HugeiconsIconProps["icon"];
  label: string;
  checked: boolean;
  onChange: () => void;
}) => (
  <div className="flex gap-4 items-center cursor-pointer" onClick={onChange}>
    <div
      className={cx(
        "h-10 w-10 shrink-0 rounded-lg transition-all flex items-center justify-center",
        checked
          ? "bg-primary-50 text-primary-500"
          : "text-content-200 bg-alpha-40"
      )}
    >
      <HugeiconsIcon icon={icon} size={20} />
    </div>

    <p className="flex-1 text-base text-content-1000 font-bold">{label}</p>

    <Checkbox
      wrapperClassName="!w-auto"
      className="cursor-pointer"
      checked={checked}
      onChange={() => {}}
    />
  </div>
);
